import React from 'react';
import { DownloadIcon } from '@heroicons/react/outline';
import { CheckCircleIcon } from '@heroicons/react/solid';

const ReceiptViewer = ({ receiptUrl }) => {
  return (
    <div className="bg-success-50 border border-success-200 rounded-lg p-6 mt-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <CheckCircleIcon className="h-6 w-6 text-success-600" />
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-success-800">
            Payment Successful!
          </h3>
          <div className="mt-2 text-sm text-success-700">
            <p>Your payment has been processed successfully. You can download your receipt below.</p>
          </div>
          <div className="mt-4">
            <a
              href={receiptUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-success-600 hover:bg-success-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success-500"
            >
              <DownloadIcon className="h-5 w-5 mr-2" />
              Download Receipt
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiptViewer; 